import { emitDialogCloseEvent, lockPageScroll, unlockPageScroll } from '../util';

// DOM
const dialogs = document.querySelectorAll('[data-sg-dialog]');
const openDialogButtons = document.querySelectorAll('[data-sg-dialog-open]');
const closeDialogButtons = document.querySelectorAll('[data-sg-dialog-close]');

// State
let hasDom = false;

function openDialog(event) {
    const dialog = document.querySelector(`[data-sg-dialog="${event.currentTarget.dataset.sgDialogOpen}"]`);
    if (dialog) {
        dialog.showModal();
        lockPageScroll();
    }
}

function closeDialog(event) {
    const dialog = event.target.closest('[data-sg-dialog]');
    if (dialog) {
        dialog.close();
        unlockPageScroll();
    }
}

function handleBackdropClick(event) {
    const dialog = event.currentTarget;
    // Close the dialog if the click happened on the backdrop
    if (event.target === dialog) {
        closeDialog(event);
    }
}

function upgrade() {
    openDialogButtons.forEach(button => {
        button.addEventListener('click', openDialog);
    });
    closeDialogButtons.forEach(button => {
        button.addEventListener('click', closeDialog);
    });    
    dialogs.forEach(dialog => {
        dialog.addEventListener('click', handleBackdropClick);
    });
    dialogs.forEach(dialog => {
        dialog.addEventListener('close', emitDialogCloseEvent);
    });        
}

function downgrade() {
    openDialogButtons.forEach(button => {
        button.removeEventListener('click', openDialog);
    });
    closeDialogButtons.forEach(button => {
        button.removeEventListener('click', closeDialog);
    });
    dialogs.forEach(dialog => {
        dialog.removeEventListener('click', handleBackdropClick);
    });
    dialogs.forEach(dialog => {
        dialog.removeEventListener('close', emitDialogCloseEvent);
    });        
}

function init() {
    hasDom = dialogs && openDialogButtons && closeDialogButtons;
    if ( ! hasDom) return;

    upgrade();
}

export default {
    init
}
